import { observable } from 'mobx';

class EditorStore {
  @observable version = 'EditorStore-1.0.0';

  @observable dom = null;
}
export default { name: 'EditorStore', Store: EditorStore };
